<div class="ss-notification-wrapper">
  <ng-container *ngIf="(totalUnread$ | async) as unread; else noUnreadData">
    <button
      type="button"
      id="notifications"
      class="ss-notification-icon"
      aria-label="Notificações"
      [attr.aria-expanded]="isShown"
      (click)="toggleNotifications()">
      <lucide-icon name="bell" [size]="18" aria-hidden="true"></lucide-icon>
      <span
        *ngIf="unread.total_unread > 0"
        class="ss-notification-icon__badge"
        [attr.title]="unread.total_unread + ' não lidas'">
        <span class="sr-only">{{ unread.total_unread }}</span>
      </span>
    </button>

    <section
      id="notificationList"
      role="dialog"
      aria-label="Notificações"
      [hidden]="!isShown"
      class="ss-notification-panel">
      <span class="ss-notification-panel__arrow" aria-hidden="true"></span>

      <div class="ss-notification-panel__header">
        <span class="ss-notification-panel__title">Notificações</span>

        <ng-template [ssHasPermission]="'notification'" [ssHasPermissionAction]="'read_all_notifications'">
          <button
            type="button"
            [hidden]="unread.total_unread == 0"
            (click)="setAllread()"
            class="ss-notification__action-btn ss-notification__read-all">
            Marcar todas como lidas
          </button>
        </ng-template>
      </div>

      <div role="tablist" class="ss-notification-panel__tabs">
        <button
          type="button"
          role="tab"
          class="ss-notification-panel__tab"
          [class.is-active]="activeTab === 'all'"
          [attr.aria-selected]="activeTab === 'all'"
          (click)="setTab('all')">
          Todas
        </button>
        <button
          type="button"
          role="tab"
          class="ss-notification-panel__tab"
          [class.is-active]="activeTab === 'unread'"
          [attr.aria-selected]="activeTab === 'unread'"
          (click)="setTab('unread')">
          Não lidas
          <span *ngIf="unread.total_unread > 0" class="ss-notification-panel__tab-badge">
            {{ unread.total_unread }}
          </span>
        </button>
      </div>

      <div class="ss-notification-list" (scroll)="onScroll($event)">
        <div *ngIf="isLoading" class="ss-notification-empty">
          <svg class="ss-notification-loading" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M14.6 33.5l-.5-.6-2.8-1.2-.4-.1c-.4 0-.7.2-.8.6a43 43 0 0 0-2.6 7.9l.1.7c.1.2.3.4.6.4l3 .6h.2c.4 0 .8-.3.9-.8a40.7 40.7 0 0 1 2.3-7.5zM84.4 65.3c.1-.3.5-.5.8-.5l.4.1 2.8 1.3.5.5v.7a42.4 42.4 0 0 1-39 25.1c-4.5 0-9.1-.7-13.4-2.1l-.9 2.2a2 2 0 0 1-1.6 1.2h-.3a2 2 0 0 1-1.6-.8l-5.8-7.6c-.3-.3-.4-.8-.4-1.2l.1-.8a2 2 0 0 1 1.6-1.2l9.5-1.3h.3c.5 0 1.1.2 1.5.6l.2.2c.3.3.4.8.4 1.2 0 .3 0 .5-.2.8l-.9 2.2A38.5 38.5 0 0 0 67 83.7a38.8 38.8 0 0 0 17.4-18.4zM63.8 13c-.1.3-.4.6-.8.6l-.3-.1c-1.9-.7-3.9-1.3-5.9-1.6-.2 0-.4-.2-.6-.4-.1-.2-.2-.4-.1-.7l.6-3c0-.2.2-.4.4-.6l.5-.2h.2c2.2.5 4.4 1.2 6.6 2 .2.1.4.2.5.5v.7L63.8 13zM49.9 11.2H48c-1.8.1-3.7.3-5.5.6h-.1a1 1 0 0 1-.9-.7l-.6-3 .1-.7c.1-.2.3-.3.6-.4 2.1-.4 4.2-.6 6.2-.7h2c.2 0 .5.1.6.3.2.2.3.4.2.6v3.1c.1.4-.2.8-.7.9zM87.9 56.5c-.5-.1-.8-.5-.7-1l.4-3.7c0-.5.4-.8.9-.8h.1l3.1.2.6.3c.2.2.2.4.2.7l-.5 4.2c0 .2-.2.4-.4.6l-.5.2h-.2l-3-.7zM74.6 19.3a1 1 0 0 1-.7.3l-.6-.2a42 42 0 0 0-4.9-3.3l-.4-.5c-.1-.2 0-.5.1-.7l1.5-2.6c.2-.3.4-.4.8-.4l.5.1c2 1.1 3.8 2.4 5.6 3.7.2.1.3.4.3.6 0 .2 0 .5-.2.6l-2 2.4zM92.3 47.4l-.6.3-3 .2c-.5 0-.9-.3-.9-.8l-.6-4.6c-.1-.5.2-.9.7-1l3-.5h.1c.2 0 .4 0 .5.2.2.1.3.3.4.6l.6 5.2-.2.4zM19 26.5c-.2.2-.4.4-.7.4l-.6-.2-2.5-1.8c-.2-.1-.3-.4-.4-.6 0-.2 0-.5.2-.7 1.7-2.2 3.6-4.3 5.6-6.1l.6-.2c.3 0 .5.1.7.3l2 2.3c.3.4.3.9-.1 1.3a41.6 41.6 0 0 0-4.8 5.3zM35.8 13.7l-1.3.5c-1.6.7-3.2 1.6-4.9 2.5l-.4.1a1 1 0 0 1-.8-.4l-1.6-2.6c-.1-.2-.2-.4-.1-.7l.4-.6c1.8-1.1 3.6-2 5.5-2.8l1.5-.6.3-.1.4.1.5.5 1.1 2.8c.1.6-.1 1.2-.6 1.3zM86.1 63c-.2-.1-.4-.2-.5-.5a51.7 51.7 0 0 0 .9-3.6c.1-.4.4-.7.8-.7h.2l3 .8.5.4c.1.2.2.5.1.7l-1 3.3c-.1.3-.4.6-.8.6l-.3-.1-2.9-.9zM85 26.4l-2.5 1.7-.5.1a1 1 0 0 1-.8-.4 34 34 0 0 0-3.3-4.2c-.2-.2-.2-.4-.2-.6 0-.2.1-.5.3-.6l2.3-2 .6-.2h.1c.2 0 .5.1.6.3 1.4 1.5 2.6 3.1 3.7 4.8.1.2.2.4.1.7l-.4.4zM89.9 37.2l-2.9.9h-.2c-.4 0-.8-.2-.9-.6a60 60 0 0 0-1.2-3.3l-.6-1.2a.9.9 0 0 1 0-.7c.1-.2.2-.4.5-.5l2.7-1.3.4-.1h.3c.2.1.4.2.5.5v.1l.6 1.3 1.4 3.8c.1.2.1.5-.1.7l-.5.4z"/></svg>
        </div>

        <div *ngIf="!isLoading && filteredNotifications.length == 0" class="ss-notification-empty">
          <span>{{ activeTab === 'unread' ? 'Tudo em dia. Nenhuma notificação não lida.' : 'Nenhuma notificação' }}</span>
        </div>

        <div
          *ngFor="let notification of filteredNotifications"
          class="ss-notification"
          tabindex="0"
          (click)="setWasRead(notification.id, notification.was_read, notification)"
          (keydown.enter)="setWasRead(notification.id, notification.was_read, notification)"
          [ngClass]="{'ss-notification--read': notification.was_read}">
          <span class="ss-notification__icon">
            <lucide-icon name="file-text" [size]="16" aria-hidden="true"></lucide-icon>
          </span>
          <span class="ss-notification__content">
            <span class="ss-notification__meta">
              <span class="ss-notification__title">{{ notificationTitle(notification) }}</span>
              <span class="ss-notification__date">{{ notification.created_at | date: 'dd/MM/yyyy' }}</span>
            </span>
            <span class="ss-notification__text">{{ notification.text }}</span>
            <a
              *ngIf="notification.link"
              href="{{ notification.link }}"
              target="_blank"
              class="ss-notification__link">
              Acessar <lucide-icon name="external-link" [size]="12" aria-hidden="true"></lucide-icon>
            </a>
          </span>
          <span class="ss-notification__dot"></span>
        </div>
      </div>

      <ng-template [ssHasPermission]="'notification'" [ssHasPermissionAction]="'read'">
        <a
          class="ss-notification-panel__footer"
          [routerLink]="appRoutes.notifications.list()"
          (click)="closeNotifications()">
          Ver todas as notificações
        </a>
      </ng-template>
    </section>
  </ng-container>

  <ng-template #noUnreadData>
    <button
      type="button"
      id="notifications"
      class="ss-notification-icon"
      aria-label="Notificações"
      [attr.aria-expanded]="isShown"
      (click)="toggleNotifications()">
      <lucide-icon name="bell" [size]="18" aria-hidden="true"></lucide-icon>
    </button>
  </ng-template>
</div>
